import { FLAVORS } from "@/lib/catalog";
import { ArrowUpRight } from "lucide-react";
import FlavorInfoButtons from "@/components/landing/FlavorInfoButtons";

export default function Flavors() {
  const toOrder = (value) => {
    window.dispatchEvent(new CustomEvent("tqb:select-flavor", { detail: value }));
    document.getElementById("pedido")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="sabores" data-testid="flavors-section" className="mx-auto max-w-[1400px] px-6 md:px-10 py-20 md:py-32">
      <div className="flex items-end justify-between flex-wrap gap-6">
        <div>
          <div className="flex items-center gap-3 text-xs md:text-sm uppercase tracking-[0.2em]">
            <span className="inline-block w-10 h-px bg-black" />
            <span>Cinco recheios. Zero concessão.</span>
          </div>
          <h2 className="font-display mt-6 text-4xl sm:text-5xl md:text-7xl leading-[0.95] tracking-[-0.02em]">
            Escolha seu <br className="hidden sm:block" />
            ato de coragem.
          </h2>
        </div>
        <p className="max-w-md text-base leading-relaxed">
          Todos os sabores são <span className="font-medium">sem açúcar, sem glúten e sem lactose</span>.
          Quatro deles em collab com{" "}
          <span className="font-medium">A Confiteria</span> — recheios fit, sem adição de
          açúcar. Mais um clássico tradicional: Beauty Protein.
        </p>
      </div>

      <div className="hairline mt-14" />

      <ul className="grid md:grid-cols-2 gap-0">
        {FLAVORS.map((f, i) => (
          <li
            key={f.slug}
            data-testid={`flavor-card-${f.slug}`}
            className={`group relative py-12 md:py-16 border-b border-black ${
              i % 2 === 0 ? "md:border-r md:pr-10" : "md:pl-10"
            }`}
          >
            <div className="grid grid-cols-12 gap-6 items-start">
              <div className="col-span-12 md:col-span-5 relative">
                <div className="relative aspect-square bg-white border border-black overflow-hidden">
                  <img
                    src={f.img}
                    alt={f.label}
                    className="absolute inset-0 w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>

              <div className="col-span-12 md:col-span-7">
                <div className="flex items-baseline gap-4">
                  <span className="font-display text-2xl md:text-3xl">{f.n}</span>
                  <span className="text-xs uppercase tracking-[0.2em]">{f.tag}</span>
                </div>
                <h3 className="font-display mt-3 text-3xl md:text-5xl tracking-[-0.02em]">
                  {f.label}
                </h3>
                <p className="mt-4 text-base leading-relaxed max-w-md">{f.desc}</p>
                <p className="mt-3 text-xs uppercase tracking-[0.2em]">+ Contém colágeno hidrolisado</p>

                <FlavorInfoButtons flavor={f} />

                {f.collab && (
                  <div className="mt-6 inline-flex items-center gap-3 border border-black px-4 py-2 text-xs uppercase tracking-[0.2em]">
                    <span className="inline-block w-2 h-2 bg-black" />
                    Collab · {f.collab.replace("A Confiteria · ", "")}
                  </div>
                )}

                <button
                  data-testid={`flavor-order-${f.slug}`}
                  onClick={() => toOrder(f.value)}
                  className="mt-6 inline-flex items-center gap-2 text-sm uppercase tracking-[0.18em] border-b border-black pb-1 hover:gap-3 transition-all"
                >
                  Pedir este sabor
                  <ArrowUpRight size={16} strokeWidth={2} />
                </button>
              </div>
            </div>
          </li>
        ))}
      </ul>

      <div className="mt-16 md:mt-20 flex flex-col md:flex-row items-start md:items-end justify-between gap-6">
        <div>
          <p className="text-xs uppercase tracking-[0.2em]">Tabela</p>
          <h3 className="font-display text-3xl md:text-5xl mt-2 tracking-[-0.02em]">Valores</h3>
        </div>
        <ul className="w-full md:w-auto md:min-w-[460px]">
          <li className="flex items-center justify-between border-t border-black py-4">
            <span className="text-base">Unidade · Tradicional (Beauty Protein)</span>
            <span className="font-display text-2xl">R$ 19,90</span>
          </li>
          <li className="flex items-center justify-between border-t border-black py-4">
            <span className="text-base">Unidade · Recheados</span>
            <span className="font-display text-2xl">R$ 23,90</span>
          </li>
          <li className="flex items-center justify-between border-y border-black py-4">
            <span className="text-base">Kit com 5 · 1 de cada sabor</span>
            <span className="font-display text-2xl">R$ 97,90</span>
          </li>
        </ul>
      </div>
    </section>
  );
}
